@if(isVisible){
<button
  class="btn btn-dark text-uppercase"
  (click)="scrollToTop()"
  aria-label="Volver arriba"
>
  <i class="fas fa-arrow-up"></i>
</button>

}
